import Icon from '../components/Icon'

Icon.register({
  gamepad: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M480.1 96c88.3 0 159.9 71.7 159.9 160 0 88.3-71.7 160-160 160-44.7 0-85.2-18.4-114.2-48h-91.5c-29 29.6-69.5 48-114.2 48-88.3 0-160-71.7-160-160s71.7-160 160-160h320.1zM248 268v-24c0-6.6-5.4-12-12-12h-52v-52c0-6.6-5.4-12-12-12h-24c-6.6 0-12 5.4-12 12v52h-52c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12h52v52c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12v-52h52c6.6 0 12-5.4 12-12zM464 344c22.1 0 40-17.9 40-40s-17.9-40-40-40-40 17.9-40 40 17.9 40 40 40zM528 248c22.1 0 40-17.9 40-40s-17.9-40-40-40-40 17.9-40 40 17.9 40 40 40z'
      }
    ]
  }
})
